import React from 'react';

/**
 * 패스워드 관리 섹션 컴포넌트
 */
function PasswordManagementSection() {
  return (
    <section id="password-management" className="guide-section">
      <h2>🔐 패스워드 관리</h2>
      
      <div className="feature-grid">
        <div className="feature-card">
          <h3>📝 패스워드 추가</h3>
          <div className="feature-steps">
            <p><strong>방법 1: 기본 추가</strong></p>
            <ol>
              <li>➕ "새 패스워드" 버튼 클릭</li>
              <li>필수 정보 입력 (제목, 패스워드)</li>
              <li>선택 정보 입력 (웹사이트, 사용자명, 태그)</li>
              <li>💾 "저장" 버튼 클릭</li>
            </ol>
            
            <p><strong>방법 2: 빠른 추가</strong></p>
            <ol>
              <li>🎲 패스워드 생성기 사용</li>
              <li>자동 생성된 안전한 패스워드 확인</li>
              <li>나머지 정보만 입력 후 저장</li>
            </ol>
          </div>
        </div>

        <div className="feature-card">
          <h3>✏️ 패스워드 수정</h3>
          <div className="feature-steps">
            <ol>
              <li>수정할 패스워드 카드에서 ✏️ 버튼 클릭</li>
              <li>수정 모드에서 정보 변경</li>
              <li>💪 패스워드 강도 실시간 확인</li>
              <li>💾 "저장" 버튼으로 변경사항 적용</li>
            </ol>
            <div className="tip-box">
              <strong>💡 팁:</strong> 패스워드 변경 시 이전 패스워드는 히스토리에 보관됩니다.
            </div>
          </div>
        </div>

        <div className="feature-card">
          <h3>📋 복사 & 사용</h3>
          <div className="feature-steps">
            <p><strong>빠른 복사:</strong></p>
            <ul>
              <li>📋 사용자명 복사 버튼</li>
              <li>🔐 패스워드 복사 버튼</li>
              <li>🌐 웹사이트 URL 복사</li>
            </ul>
            
            <p><strong>보기/숨기기:</strong></p>
            <ul>
              <li>👁️ 패스워드 보기/숨기기 토글</li>
              <li>🔒 보안을 위한 자동 숨김</li>
            </ul>
          </div>
        </div>

        <div className="feature-card">
          <h3>🗑️ 패스워드 삭제</h3>
          <div className="feature-steps">
            <ol>
              <li>삭제할 패스워드 카드에서 🗑️ 버튼 클릭</li>
              <li>확인 대화상자에서 "삭제" 확인</li>
              <li>즉시 Firebase에서 완전 삭제</li>
            </ol>
            <div className="warning-box">
              <strong>⚠️ 주의:</strong> 삭제된 패스워드는 복구할 수 없습니다.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PasswordManagementSection;